import React from "react";
import { Grid, Typography, Divider } from "@mui/material";
import { Container } from "../Education/styled";
import ChallengesBanner from "@js/components/Education/EducationBanner";

const ChallengesUnderConstruction = () => {
    return (
        <Container>
            <Typography>Challenges</Typography>
            <ChallengesBanner
                bannerTitle={"Challenge your Starknet developer skills!"}
                bannerSubtext={
                    "Showcase your skills by solving hard problems, or create your own problems for others to solve!"
                }
                hasBannerImage={true}
            />
            <Grid container>
                <Grid
                    item
                    sx={{
                        marginTop: "25px",
                    }}
                    xs={12}
                >
                    <Divider />
                    <Grid
                        item
                        justifyContent={"space-between"}
                        display={"flex"}
                        marginTop={"20px"}
                        xs={12}
                        mb={4}
                    >
                        <Typography fontWeight={"bold"} display={"inline-flex"}>
                            Challenge Questions
                        </Typography>
                        We are currently making exciting improvements to
                        Challenge questions, check back soon!
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ChallengesUnderConstruction;
